import LocaleMixin from "./LocaleMixin.js";
import Account from "@/helper/AccountHelper.js";
export default {
    mixins: [LocaleMixin],
    methods: {
        errorApi: function(err, callback) {
            let alertMsg = '';
            let defalutCase = true;
            let errorId = err?.id != null ? err?.id : err?.code;

            if (errorId) {
                switch (errorId) {
                    case 401:
                        alertMsg = err.message;
                        break;
                    case 412:
                        alertMsg = "Token invalid";
                        defalutCase = false;
                        break;
                    case 1905:
                        alertMsg = this.lbl.error_user_delete;
                        defalutCase = false;
                        break;
                    case 'user_delete':
                        alertMsg = err.message;
                        defalutCase = false;
                        break;
                    default:
                        alertMsg = err.message;
                        break;
                }
            } else {
                alertMsg = "Network connection error!";
            }

            if (err?.code == 409 && err?.id == 1905) {
                alertMsg = this.lbl.error_mantain;
                defalutCase = false;
            }

            if (typeof callback == 'function' && !defalutCase) {
                callback(err);
            }

            if (this.modal.errorModal != null) {
                this.modal.errorModal
                    .clearModal()
                    .setMsg(alertMsg)
                    .show();
                this.modal.errorModal.onClose(() => {
                    if (errorId == 1905) {
                        this.logout();
                    } else {
                        return;
                    }
                });
            }
        },

        logout: async function () {
            if (Account.isLoginWithFacebook()) {
                await this.logoutFacebook();
            }

            this.logoutBzbs();
        },

        logoutBzbs: function () {
            Account.setLogout().then(() => {
                window.location.replace('/home');
            }).catch(() => {
                window.location.replace('/home');
            });
        },
    }
}
